import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { FamilyTreeCanvas } from "../FamilyTreeCanvas";
import styled from 'styled-components';

const PageContainer = styled.div`
`;

export const FamilyTreePage = () => {
  const [treeData, setTreeData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [highlightedId, setHighlightedId] = useState<string | null>(null);

  const fetchTree = async () => {
    try {
      const response = await fetch(location.protocol + '//saadacohen.com/server/get_tree.php');
      if (!response.ok) {
        throw new Error("Failed to fetch family tree");
      }

      const responseData = await response.json();
      setTreeData(responseData.map((item: any) => ({...item, children: item.children ? JSON.parse(item.children) : undefined})));
    } catch (error) {
      console.error("Error fetching family tree:", error);
    }
  };

  useEffect(() => {
    fetchTree();
  }, []);

  const handleSearch = () => {
    const found = treeData.find((p) => p.name.includes(searchTerm));
    if (found) {
      setHighlightedId(found.id);
    } else {
      setHighlightedId(null);
      alert("לא נמצא אדם עם שם זה");
    }
  };
  
  return (
	<PageContainer>
		<FamilyTreeCanvas
          people={treeData}
          rootId="I500030"
        />
	</PageContainer>
  );
};

export default FamilyTreePage;
